import React, { useState, useEffect } from "react";
import { Button, CardMedia, Stack, Typography } from "@mui/material";


// import Img5 from "./svgImage/Afternoon/Telecom-Service-5pm.webp";
// import Img5 from "./svgImage/Afternoon/Telecome service.png";
import Img5 from "./svgImage/Afternoon/telecom.webp";
import LeadGen from "./svgImage/Afternoon/Lead-2pm.webp";
// import CarInsurance from "./svgImage/Afternoon/car-insuranc-4pm.webp";
import CarInsurance from "./svgImage/Afternoon/Car insurance.webp";
import Meeting from "./svgImage/Afternoon/Meeting-1pm.webp";
import Broadcasting from "./svgImage/Afternoon/Broadcasting1.webp";
import { Image } from "@mui/icons-material";

const FrameSection1B = ({ currentIndex, setCurrentIndex }) => {
  const slides = [
    {
      id: 1,
      image: Img5,
      title: "PM 1",
      description: "The Ultimate Show-and-Sell Tool",
      paragraph: "CarouselMarketing | BoostSales | MarketingMadeEasy",
    },
    {
      id: 2,
      image: LeadGen,
      title: "PM 2",
      description: "Made Easy on WhatsApp",
      paragraph: "BusinessMadeEasy | ShopSmartWithWhatsApp | SeamlessShopping",
    },
    {
      id: 3,
      image: CarInsurance,
      title: "PM 3",
      description: "Confirm with WhatsApp Breeze",
      paragraph: "SecurePayments | FastTransactions | PaymentSimplified",
    },
    {
      id: 4,
      image: Meeting,
      title: "PM 4",
      description: "Through WhatsApp Interactive Flow",
      paragraph:
        "WhatsAppFlow | InteractiveFeedback | CustomerInsightsSimplified",
    },
    {
      id: 5,
      image: Broadcasting,
      title: "PM 5",
      description: "WhatsApp Business Connect",
      paragraph: "WhatsAppCalling | SeamlessSupport | TalkWithWhatsApp",
    },
  ];

  // const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Stack
      sx={{
        position: "relative",
        width: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        height: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        margin: "auto",
        overflow: "hidden",
        borderRadius: "8px",
        // marginTop: { xl: "60px" },
        // border: "1px solid red",
      }}
    >
      {/* Slides */}
      <Stack
        direction="row"
        sx={{
          display: "flex",
          // border: "2px solid green",
          width: "100%",
          height: "100%",
          paddingLeft: { xl: "80px", lg: "80px", md: "32px", sm: "80px" },
          paddingRight: { xl: "80px", lg: "80px", md: "32px", sm: "80px" },
        }}
      >
        <img
          src={slides[currentIndex].image}
          alt={slides[currentIndex].title}
          style={{
            width: "100%",
            height: "100%",
            backgroundSize: "cover", // Ensures the image covers the entire container
            backgroundPosition: "center", // Centers the image in the container
            backgroundRepeat: "no-repeat",
            // border: "2px solid blacks",
          }}
        />
      </Stack>

      {/* Navigation Buttons */}
      <Button
        onClick={goToPrevious}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          left: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❮
      </Button>
      <Button
        onClick={goToNext}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          right: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❯
      </Button>
    </Stack>
  );
};

export default FrameSection1B;
